import interceptors from '@/api/supplier/interceptorsSupplier';
import { clientSupplier } from '@/api/supplier/client';

clientSupplier.interceptors.request.use(interceptors.auth, interceptors.onError);

function getOptionWarehouse() {
    return clientSupplier.get("api-supplier/options/warehouse");
}

function getOptionType() {
    return clientSupplier.get("api-supplier/options/user-type");
}

function getOptionProvince() {
    return clientSupplier.get("api-supplier/options/area-province");
}

function getOptionCity(params) {
    return clientSupplier.get("api-supplier/options/area-city", {
        params: params,
    });
}

function getOptionSubdistrict(params) {
    return clientSupplier.get("api-supplier/options/area-subdistrict", {
        params: params,
    });
}

function getOptionWarehouseArea(params) {
    return clientSupplier.get("api-supplier/options/warehouse-area", {
        params: params,
    });
}

function getOptionProduct() {
    return clientSupplier.get("api-supplier/options/product");
}

function getOptionSupplier() {
    return clientSupplier.get("api-supplier/options/supplier");
}

function poforApprove() {
    return clientSupplier.get("api-supplier/options/po_for_approve");
}

function getOptionReturforAccept() {
    return clientSupplier.get("api-supplier/options/retur-for-approve");
}

export default {
    getOptionProvince,
    getOptionWarehouse,
    getOptionType,
    getOptionCity,
    getOptionSubdistrict,
    getOptionWarehouseArea,
    getOptionProduct,
    getOptionSupplier,
    getOptionReturforAccept,
    poforApprove
};